export default function ({
  $config
}) {
  if (process.browser) {
    window.onNuxtReady(app => {
      if ($config.disableIntercom) {
        setTimeout(() => {
          app.$intercom.shutdown();
          app.$intercom.hide();
        }, 500);
      } else {
        app.$intercom.boot();

        const ref = () => document.querySelector('.intercom-lightweight-app-launcher-icon');

        const refParent = () => document.querySelector('.intercom-launcher');

        const refIframe = () => document.querySelector('.intercom-app iframe.intercom-launcher-frame').contentDocument.querySelector('svg[viewBox="0 0 28 32"]');

        const svg = '<svg width="26" height="21" viewBox="0 0 26 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.83334 3.93209C4.30774 5.46239 0.899206 9.41675 0.152896 14.25C0.0522295 14.9019 0 15.5699 0 16.25H26C26 15.5699 25.9478 14.9019 25.8471 14.25C25.1008 9.41675 21.6923 5.4624 17.1667 3.9321C16.5212 3.71385 15.8531 3.5449 15.1667 3.42975C14.4621 3.31153 13.7382 3.25 13 3.25C12.2618 3.25 11.538 3.31153 10.8333 3.42974C10.1469 3.5449 9.47878 3.71384 8.83334 3.93209ZM23.8186 14.25C22.8781 9.12976 18.3921 5.25 13 5.25C7.60786 5.25 3.12189 9.12976 2.18138 14.25H23.8186ZM10.8333 2H15.1667V0H10.8333V2ZM0 20.3333V18.3333H26V20.3333H0Z" fill="white"/></svg>';
        const interval = setInterval(() => {
          const el = ref();
          const elParent = refParent(); // console.log('[intject]', !el ? 'no...' : 'YES')

          if (!elParent || !el) {// console.log('[intject]', 'no ref :(')
          } else if (el && elParent && !elParent.classList.contains('custom-1337')) {
            // console.log('[intject]', 'OOOooo injecting')
            el.innerHTML = svg;
            elParent.classList.add('custom-1337');
          } else if (el && elParent && elParent.classList.contains('custom-1337')) {
            clearInterval(interval); // console.log('[intject]', 'big success')

            observeIframe();
          }
        }, 300);

        function observeIframe() {
          const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
              if (mutation.type === 'childList' && mutation.removedNodes.length > 0 && mutation.removedNodes[0].classList.contains('intercom-lightweight-app')) {
                const el = refIframe(); // console.log({ el })

                if (el) {
                  el.outerHTML = svg;
                  el.classList.add('custom-1337');
                  observer.disconnect();
                }
              }
            }
          };

          const observer = new MutationObserver(callback); // console.log(observer)

          observer.observe(document.body, {
            childList: true
          });
        }
      }
    });
  }
}